import {useEffect, useState} from 'react'
import {Link, useParams, Navigate} from 'react-router-dom'
import {api, InfoPage as InfoPageT, ApiError} from '../../services/api'
import {Container, PageHero} from './ui'
import {BRAND} from './site'
import {Markdown} from '../../components/Markdown'

const InfoPage = () => {
  const {slug} = useParams()
  const [page, setPage] = useState<InfoPageT | null>(null)
  const [others, setOthers] = useState<InfoPageT[]>([])
  const [status, setStatus] = useState<'loading' | 'ready' | 'notfound'>('loading')

  useEffect(() => {
    if (!slug) return
    setStatus('loading')
    Promise.all([api.publicInfoPage(slug), api.publicInfoPages().catch(() => [])])
      .then(([p, all]) => {
        setPage(p)
        setOthers(all.filter((x) => x.slug !== p.slug))
        setStatus('ready')
      })
      .catch((e) => setStatus(e instanceof ApiError && e.status === 404 ? 'notfound' : 'notfound'))
  }, [slug])

  if (status === 'notfound') return <Navigate to='/' replace />
  if (status === 'loading' || !page) {
    return (
      <div style={{minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: BRAND.muted}}>
        Loading…
      </div>
    )
  }

  return (
    <div style={{background: BRAND.soft, paddingBottom: 64}}>
      <PageHero title={page.title} />
      <Container style={{padding: '40px 20px', maxWidth: 860}}>
        <div className='ccp-fade-up' style={{background: '#fff', borderRadius: 18, border: '1px solid #eef0f4', boxShadow: '0 12px 36px rgba(27,27,41,0.07)', padding: '36px 40px'}}>
          <Markdown>{page.body}</Markdown>
          <div style={{marginTop: 28, paddingTop: 18, borderTop: '1px solid #eef0f4', fontSize: 13, color: BRAND.muted}}>
            Last updated {new Date(page.updatedAt).toLocaleDateString(undefined, {dateStyle: 'medium'})}
          </div>
        </div>

        {others.length > 0 && (
          <div style={{marginTop: 40}}>
            <h2 style={{fontSize: 20, fontWeight: 800, color: BRAND.ink, margin: '0 0 16px'}}>More info</h2>
            <div className='row g-3 ccp-stagger'>
              {others.map((o) => (
                <div className='col-12 col-sm-6' key={o.id}>
                  <Link to={`/info/${o.slug}`} className='ccp-lift' style={{display: 'block', textDecoration: 'none', background: '#fff', border: '1px solid #eef0f4', borderRadius: 14, padding: '18px 20px', boxShadow: '0 6px 18px rgba(27,27,41,0.05)', height: '100%'}}>
                    <div style={{fontSize: 16, fontWeight: 800, color: BRAND.ink}}>{o.title}</div>
                    <div style={{fontSize: 14, color: BRAND.green, fontWeight: 600, marginTop: 8}}>Read →</div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        )}
      </Container>
    </div>
  )
}

export {InfoPage}
